<template>
  <header class="site-header">
    <nav class="nav-shell" aria-label="Primary navigation">
      <router-link class="brand" to="/" @click="closeMenu">
        <span class="brand-mark" aria-hidden="true">
          <img src="../assets/logo-x3-blackandwhite.png" alt="" />
        </span>
        <span class="brand-copy">
          <strong>AliTutor</strong>
          <small>Accounting, explained.</small>
        </span>
      </router-link>

      <div
        id="primary-navigation"
        class="nav-panel"
        :class="{ open: menuOpen }"
      >
        <router-link to="/howitworks" class="nav-link" @click="closeMenu">
          Tutoring Process
        </router-link>
        <router-link to="/about" class="nav-link" @click="closeMenu">
          About Ali
        </router-link>
        <router-link to="/contact" class="nav-cta" @click="closeMenu">
          Book Free Consult
          <i class="fas fa-arrow-right" aria-hidden="true"></i>
        </router-link>
      </div>

      <button
        class="menu-button"
        type="button"
        aria-label="Toggle navigation"
        aria-controls="primary-navigation"
        :aria-expanded="menuOpen"
        @click="menuOpen = !menuOpen"
      >
        <span></span>
        <span></span>
      </button>
    </nav>
  </header>
</template>

<script setup>
import { ref } from "vue";

const menuOpen = ref(false);
const closeMenu = () => {
  menuOpen.value = false;
};
</script>

<style lang="scss" scoped>
.site-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  border-bottom: 1px solid rgba(223, 227, 236, 0.8);
  background: rgba(246, 247, 251, 0.9);
  backdrop-filter: blur(18px);
}

.nav-shell {
  display: flex;
  width: min(1240px, calc(100% - 40px));
  height: 78px;
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
}

.brand-mark {
  display: grid;
  width: 44px;
  height: 44px;
  place-items: center;
  border: 1px solid var(--line);
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(10, 16, 32, 0.08);

  img {
    width: 29px;
    height: 29px;
    object-fit: contain;
  }
}

.brand-copy {
  display: flex;
  flex-direction: column;
  line-height: 1.05;

  strong {
    font-size: 1.12rem;
    letter-spacing: -0.03em;
  }

  small {
    margin-top: 0.3rem;
    color: var(--muted);
    font-size: 0.67rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }
}

.nav-panel {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.nav-link {
  position: relative;
  color: #4c5871;
  font-size: 0.92rem;
  font-weight: 700;
  transition: color 180ms ease;

  &::after {
    position: absolute;
    right: 0;
    bottom: -0.6rem;
    left: 0;
    height: 2px;
    border-radius: 99px;
    background: var(--blue);
    content: "";
    opacity: 0;
    transform: scaleX(0.3);
    transition: all 180ms ease;
  }

  &:hover,
  &.router-link-active {
    color: var(--ink);

    &::after {
      opacity: 1;
      transform: scaleX(1);
    }
  }
}

.nav-cta {
  display: inline-flex;
  align-items: center;
  gap: 0.7rem;
  padding: 0.82rem 1.08rem;
  border-radius: 14px;
  background: var(--ink);
  color: #fff;
  font-size: 0.86rem;
  font-weight: 800;
  box-shadow: 0 10px 26px rgba(10, 16, 32, 0.18);
  transition: transform 180ms ease, background 180ms ease;

  &:hover {
    background: var(--blue);
    transform: translateY(-2px);
  }
}

.menu-button {
  display: none;
  width: 44px;
  height: 44px;
  border: 1px solid var(--line);
  border-radius: 14px;
  background: #fff;
  cursor: pointer;

  span {
    display: block;
    width: 20px;
    height: 2px;
    margin: 5px auto;
    border-radius: 2px;
    background: var(--ink);
  }
}

@media (max-width: 780px) {
  .nav-shell {
    width: min(100% - 28px, 1240px);
  }

  .brand-copy small {
    display: none;
  }

  .menu-button {
    display: block;
  }

  .nav-panel {
    position: absolute;
    top: 68px;
    right: 14px;
    left: 14px;
    display: grid;
    gap: 0.25rem;
    padding: 0.8rem;
    border: 1px solid var(--line);
    border-radius: 20px;
    background: #fff;
    box-shadow: var(--shadow);
    opacity: 0;
    pointer-events: none;
    transform: translateY(-10px);
    transition: all 180ms ease;

    &.open {
      opacity: 1;
      pointer-events: auto;
      transform: translateY(0);
    }
  }

  .nav-link {
    padding: 0.9rem 1rem;
    border-radius: 12px;

    &::after {
      display: none;
    }

    &:hover,
    &.router-link-active {
      background: var(--paper);
    }
  }

  .nav-cta {
    justify-content: center;
    margin-top: 0.3rem;
  }
}
</style>
